import React from "react";
import "./styles/TermsOfUse.css"; // Don't forget to create a CSS file for styling

const TermsOfUse = () => {
  return (
    <div className="terms-of-use">
      <h1>Terms of Use</h1>

      <section>
        <h2>1. Introduction</h2>
        <p>
          These terms of use govern your access to and use of our website and
          newsletter. By subscribing to our newsletter, you acknowledge that you
          have read, understood, and agreed to these terms. If you do not agree
          with these terms, you should not subscribe to our newsletter or use
          our website.
        </p>
      </section>

      <section>
        <h2>2. Services Provided</h2>
        <p>
          By subscribing to our newsletter, you will receive periodic emails
          containing information, updates, news, and promotional offers related
          to our services and topics of interest. The content of the newsletter
          may be modified or updated at any time, and you will be notified of
          significant changes when necessary.
        </p>
      </section>

      <section>
        <h2>3. Use of the Website and Newsletter</h2>
        <p>
          You agree to use our website and newsletter for lawful purposes only
          and in accordance with applicable laws. This includes refraining from
          using the content for illegal activities, spamming, or distributing
          harmful content. You are responsible for providing accurate
          information, such as your email address, and keeping this information
          up to date to ensure the proper delivery of the newsletter.
        </p>
      </section>

      <section>
        <h2>4. Intellectual Property</h2>
        <p>
          All content on our website and in the newsletter, including but not
          limited to text, images, logos, and designs, is protected by
          intellectual property rights. These materials are owned by us or
          licensed to us. You may not copy, reproduce, distribute, or create
          derivative works of any content without obtaining prior written
          consent. Unauthorized use of any material constitutes a violation of
          intellectual property laws.
        </p>
      </section>

      <section>
        <h2>5. Unsubscribing</h2>
        <p>
          You have the right to unsubscribe from our newsletter at any time.
          Each email we send will include an unsubscribe link, which you can
          click to stop receiving further emails. Upon unsubscribing, you will
          no longer receive our newsletter unless required by law, regulation,
          or legal processes. Please note that it may take a few days for your
          unsubscription to take effect.
        </p>
      </section>

      <section>
        <h2>6. Limitation of Liability</h2>
        <p>
          While we make every effort to ensure that our website and newsletter
          are free from viruses, bugs, or other issues, we cannot guarantee that
          the website will be uninterrupted or error-free. We are not liable for
          any damages, including but not limited to direct, indirect,
          incidental, or consequential damages, resulting from the use of our
          website or the receipt of our newsletter.
        </p>
      </section>

      <section>
        <h2>7. Modifications to the Terms</h2>
        <p>
          We reserve the right to modify these terms of use at any time, at our
          discretion. Any changes will be posted on this page with an updated
          revision date. It is your responsibility to review these terms
          periodically to stay informed of any changes. Continued use of our
          website or newsletter after such modifications constitutes your
          acceptance of the updated terms.
        </p>
      </section>

      <section>
        <h2>8. Contact</h2>
        <p>
          For any questions or concerns regarding these terms of use, or if you
          would like to exercise any of your rights under these terms, please
          contact us at{" "}
          <a href="mailto:support@weeklycyber.com">support@weeklycyber.com</a>.
        </p>
      </section>

      {/* Section for the last updated date */}
      <section className="last-updated">
        <p>
          <strong>Last updated:</strong> Mars 17, 2025
        </p>
      </section>
    </div>
  );
};

export default TermsOfUse;
